import PropTypes from "prop-types";
import * as Yup from "yup";
import { useCallback, useMemo, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import OutlinedInput from "@mui/material/OutlinedInput";
// @mui
import LoadingButton from "@mui/lab/LoadingButton";
import { FormControl, InputLabel, Input } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";

import { useRouter } from "src/routes/hooks";
import Swal from "sweetalert2";

import Iconify from "src/components/iconify";
import {
  RHFTextField,
  RHFUpload,
  RHFAutocomplete,
} from "src/components/hook-form";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import httpCommon from "src/http-common";

import { getValue } from "@mui/system";
import { RxCrossCircled } from "react-icons/rx";

import LoderImg from "./Spain_loderImg.gif";

// ----------------------------------------------------------------------

export default function PendingStatus({
  selectedRowID,
  closeModalPending,
  workReqestNumber,
  setRefetch,
  refetch,
}) {
  const router = useRouter();

  const getId = localStorage.getItem("ww_emp_mst_empl_id");
  const getHsp = localStorage.getItem("ww_Hsp");
  const [loading, setLoading] = useState(false);
  const [imageDialog, setImageDialog] = useState(false);
  const [imageData, setImageData] = useState("");
  const [loadingLabel, setLabelLoading] = useState({
    workArea: false,
    level: false,
    assetLocation: false,
    assetNumber: false,
    faultCode: false,
    priority: false,
  });
  const SelectedUserId = selectedRowID;
  localStorage.setItem("customRowId", selectedRowID);
  console.log("rowIDDD", localStorage.getItem("customRowId"));
  const [UserDt, setUserDt] = useState([]);
  const [UserDtImg, setUserDtImg] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState("");
  const [email, setEmail] = useState("");
  const [imageFile, setImageFile] = useState([]);
  const [empl, setEmpl] = useState("");

  // const Username = UserInfoData.wkr_mst_requestor || '';
  // const userdept = UserInfoData.wkr_mst_dept || '';

  const [NameDT, setNameDT] = useState();

  const [DeptDT, setDeptDT] = useState();
  const [PhnDT, setPhnDT] = useState();
  const [ImgId, setImgId] = useState([]);

  const url = httpCommon.defaults.baseURL;
  const [FilledFormData, setFilledFormData] = useState({
    workArea: "",
    level: "",
    assetLocation: "",
    assetNumber: "",
    workGroup: "",
    originalProperty: "",
    faultyCode: "",
    workDescription: "",
    workAreaKey: "",
    levelKey: "",
    assetLocationKey: "",
    assetNumberKey: "",
    workGroupKey: "",
    originalPropertyKey: "",
    faultyCodeKey: "",
  });
  const [WorkGrpKey, setWorkGrpKey] = useState("");

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const [DrpData, setDrpData] = useState([]);
  const [DrpDataLeval, setDrpDataLeval] = useState([]);
  const [DrpAssetLocation, setDrpAssetLocation] = useState([]);
  const [DrpAssetNo, setDrpAssetNo] = useState([]);
  const [DrpWorkGroup, setDrpWorkGroup] = useState([]);
  const [imagesArr, setImagesArr] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [drpWorkArea, setDrpWorkArea] = useState([]);
  const [DrpPriority, setDrpPriority] = useState([]);
  const [DrpFaulty, setDrpFaulty] = useState([]);
  const [imageName, setImageName] = useState({
    i1: "",
    i2: "",
  });

  const NewUserSchema2 = Yup.object().shape({
    // reqDescriptin: Yup.string().required('Request Description is required'),
    // location: Yup.string().required('Room No is required'),
    // service: Yup.string().required('Service is required'),
    // level: Yup.string().required('Level is required'),
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const NewUserSchema = Yup.object().shape({
    // empId: Yup.string().required('Employe Id is required'),
    // name: Yup.string().required('Name is required'),
    // department: Yup.string().required('Department is required'),
    // contactNo: Yup.string().required('Contact number is required'),
    // email: Yup.string().required('Email is required'),
    //  service: Yup.string().required('Service is required'),
    //  level: Yup.string().required('Level is required'),
    //  reqDescriptin: Yup.string().required('Request Description is required'),
    //  location: Yup.string().required('Room No is required'),
    // images: Yup.mixed().nullable().required('Images is required'),
    // not required
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const handleConfirm = () => {
    if (textareaValue === "") {
      // Swal.fire({
      //   title: `Please enter a reason for cancellation`,
      //   icon: 'error',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   timer: 2000,
      // });
      setErrorMsg("Please enter a reason for cancellation");
      setTimeout(() => setErrorMsg(""), 5000);
    } else {
      setConfirmDialog(true);
    }
  };
  const handleNameChange = (event) => {
    setNameDT(event.target.value);
  };
  const handleDeptChange = (event) => {
    setDeptDT(event.target.value);
  };
  const handlePhnChange = (event) => {
    // setPhnDT(event.target.value);
  };

  const handleImageDialog = (ImageUrl) => {
    // Check if ImageUrl is a string
    if (typeof ImageUrl !== "string") {
      setImageData((pre) => ({
        ImageUrl: ImageUrl.preview,
        head: ImageUrl.path,
      }));
      setImageDialog(true);
      return;
    }

    const newStr = ImageUrl.replace(`${url}/upload//`, "");
    if (imageName.i1) {
      setImageData((pre) => ({ ImageUrl, head: imageName.i1 }));
    } else if (imageName.i2) {
      setImageData((pre) => ({ ImageUrl, head: imageName.i2 }));
    }

    setImageDialog(true);
  };

  const selectedSchema =
    NameDT !== "" || DeptDT !== "" || PhnDT !== ""
      ? NewUserSchema2
      : NewUserSchema;

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });

  const {
    reset,
    watch,
    setValue,
    trigger,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const [errorMessage, setErrorMessage] = useState("");

  // Get Api All Data
  useEffect(() => {
    setLoading(true);
    const fetchUserWorkListData = async () => {
      try {
        const response = await httpCommon.get(
          `/getPendingStatusFormData.php?RowID=${SelectedUserId}&siteCd=${getHsp}`,
        );

        if (response.data.status === "SUCCESS") {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setUserDt(response.data.data1);
          setWorkGrpKey(response.data.data1[0].wkr_mst_work_group);

          const images = watch("images") || [];
          const newImages = [];

          if (response.data.data1[0]) {
            if (response.data.data1[0].img_path) {
              newImages.push(`${url}/${response.data.data1[0].img_path}`);
            }
            if (response.data.data1[0].file_name) {
              setImageName((pre) => ({
                ...pre,
                i1: response.data.data1[0].file_name,
              }));
            }
          }

          if (response.data.data1[1]) {
            if (response.data.data1[1].file_name) {
              newImages.push(`${url}/${response.data.data1[1].img_path}`);
            }
            if (response.data.data1[1].img_path) {
              setImageName((pre) => ({
                ...pre,
                i2: response.data.data1[1].img_path,
              }));
            }
          }

          if (response.data.data1[2]) {
            if (response.data.data1[2].img_path) {
              newImages.push(`${url}/${response.data.data1[2].img_path}`);
            }
          }

          setImagesArr([...newImages]);
          setValue("images", [...images, ...newImages], {
            shouldValidate: true,
          });
          setFilledFormData((prev) => {
            const data = response.data.data1 && response.data.data1[0];
            console.log("api data", data);
            return {
              ...prev,
              workArea: data
                ? `${data.wkr_mst_work_area} : ${data.work_area_desc}`
                : "",
              level: data
                ? `${data.wkr_mst_location} : ${data.wkr_mst_location_desc}`
                : "",
              assetLocation: data
                ? `${data.wkr_mst_assetlocn} : ${data.wkr_mst_assrtlocn_desc}`
                : "",
              assetNumber: data
                ? `${data.wkr_mst_assetno} : ${data.wkr_mst_assetno_desc}`
                : "",
              workGroup: data
                ? `${data.wkr_mst_work_group} : ${data.work_group_desc}`
                : "",
              // originalProperty: data
              //   ? `${data.wkr_mst_orig_priority} : ${data.orig_priority_desc}`
              //   : '',
              faultyCode: data
                ? `${data.wkr_mst_fault_code} : ${data.fault_code_desc}`
                : "",
              workDescription: data ? data.wkr_mst_wr_descs : "",
              workAreaKey: data ? data.wkr_mst_work_area : "",
              levelKey: data ? data.wkr_mst_location : "",
              assetLocationKey: data ? data.wkr_mst_assetlocn : "",
              assetNumberKey: data ? data.wkr_mst_assetno : "",
              workGroupKey: data ? data.wkr_mst_work_group : "",
              // originalPropertyKey: data ? data.wkr_mst_orig_priority : '',
              faultyCodeKey: data ? data.wkr_mst_fault_code : "",
            };
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId, setFilledFormData, setValue, watch, url]);
  // workGroup droupDown
  useEffect(() => {
    const workGroupdown = async () => {
      const cid = localStorage.getItem("ww_Hsp");

      try {
        const response = await httpCommon.get(
          `/WorkGroupDropDown.php?site_cd=${cid}`,
        );

        if (response.data.status === "SUCCESS") {
          setDrpWorkGroup(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    workGroupdown();
  }, []);

  // Work area droup Down
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      workArea: true,
    }));
    // workarea droupDown
    const getDrpWorkArea = async () => {
      const site = getHsp;
      try {
        const response = await httpCommon.get(
          `/WorkAreaDropDown.php?site_cd=${site}`,
        );

        if (response.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            workArea: false,
          }));
          setDrpWorkArea(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the DrpWorkArea function when the component mounts.
    getDrpWorkArea();
  }, [getHsp]);

  // FaultCode DroupDown
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      faultCode: true,
    }));
    const getFaultCode = async () => {
      try {
        const res = await httpCommon.get(
          `FaultCodeDropdown.php/?site_cd=${getHsp}`,
        );

        if (res.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            faultCode: false,
          }));
          setDrpFaulty(res.data.data);
        } else {
          console.log(res.data.data.status);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getFaultCode();
  }, [getHsp]);

  // get Priority DroupDown
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      priority: true,
    }));
    const getPriority = async () => {
      try {
        const res = await httpCommon.get(
          `/OriginalPriorityDropdown.php/?site_cd=${getHsp}`,
        );

        if (res.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            priority: false,
          }));
          setDrpPriority(res.data.data);
        } else {
          console.log(res.data.status);
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPriority();
  }, [getHsp]);

  // Define LevalDropdown function
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      level: true,
    }));
    const LevalDropdown = async (workArea) => {
      const cid = localStorage.getItem("ww_Hsp");

      try {
        const response = await httpCommon.get(
          `/levelDropdown.php/?site_cd=${cid}&wrk_Ara=${workArea}`,
        );

        if (response.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            level: false,
          }));
          setDrpDataLeval(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the LevalDropdown function with the appropriate argument
    LevalDropdown(FilledFormData.workAreaKey);
  }, [getHsp, FilledFormData.workAreaKey]);

  // Asset Location Droupdown
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      assetLocation: true,
    }));

    // Define LevalDropdown function
    const getLocationAsset = async (workArea, level) => {
      const id = localStorage.getItem("ww_Hsp");

      try {
        const response = await httpCommon.get(
          `/AssetLocationDropdown.php/?site_cd=${id}&ast_lvl=${level}&wrk_Ara=${workArea}`,
        );
        console.log("AssetLocation", response);

        if (response.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            assetLocation: false,
          }));
          setDrpAssetLocation(response.data.data);
          // getAssetNumber();
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Call the LevalDropdown function with the appropriate argument
    getLocationAsset(FilledFormData.workAreaKey, FilledFormData.levelKey);
  }, [getHsp, FilledFormData.workAreaKey, FilledFormData.levelKey]);

  // Define AssetDroupDown function
  useEffect(() => {
    setLabelLoading((pre) => ({
      ...pre,
      assetNumber: true,
    }));
    const getAssetNumber = async (workArea, level, assetlocation) => {
      const cid = localStorage.getItem("ww_Hsp");

      try {
        const response = await httpCommon.get(
          `/assetNoDropDown.php/?site_cd=${cid}&ast_lvl=${level}&wrk_Ara=${workArea}&asset_locn=${assetlocation}`,
        );

        if (response.data.status === "SUCCESS") {
          setLabelLoading((pre) => ({
            ...pre,
            assetNumber: false,
          }));
          setDrpAssetNo(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the LevalDropdown function with the appropriate argument
    getAssetNumber(
      FilledFormData.workAreaKey,
      FilledFormData.levelKey,
      FilledFormData.assetLocationKey,
    );
  }, [
    getHsp,
    FilledFormData.workAreaKey,
    FilledFormData.levelKey,
    FilledFormData.assetLocationKey,
  ]);
  // Asset DroupDown

  // get UserInformation
  useEffect(() => {
    setLoading(true);
    const fetchUserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: selectedRowID,
      };

      try {
        const response = await httpCommon.post("/GetUserInfo.php", requestData);

        if (response.data.status === "SUCCESS") {
          setTimeout(() => {
            setLoading(false);
          }, 1000);

          setEmpl(response.data.data.query1_response[0].emp_mst_empl_id);
          setNameDT(response.data.data.query1_response[0].emp_mst_name);

          setDeptDT(response.data.data.query1_response[0].emp_det_department);

          setPhnDT(response.data.data.query1_response[0].emp_mst_homephone);
          setEmail(response.data.data.query1_response[0].emp_det_email_id);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };
    fetchUserInfo();
  }, [getHsp, getId, setValue, selectedRowID]);

  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove("customNav");
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem("dataDark");
      // console.log("storedValue++", storedValue);
      if (storedValue === "dark") {
        document.body.classList.add("custom-darkClass");
      } else {
        document.body.classList.remove("custom-darkClass");
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove("custom-darkClass");
    };
  }, []);

  // getUser Info
  useEffect(() => {
    setLoading(true);
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: SelectedUserId,
      };
      try {
        const response = await httpCommon.post(
          "/getUserWRInfo.php",
          requestData,
        );
        console.log("response", response);
        if (response.data.status === "SUCCESS") {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].wkr_mst_phone);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId, SelectedUserId]);

  const values = watch();
  console.log("ImageNAme", imageName);
  // handle submit
  const onSubmitData = async (data) => {
    const formData = new FormData();

    const requestData = {
      employeeID: getId,
      site_cd: getHsp,
      wkr_mst_homephone: PhnDT,
      gs_user: NameDT,
      wkr_mst_email: email,
      wkr_mst_work_group: FilledFormData.workGroupKey,
      wkr_mst_location: FilledFormData.levelKey,
      wkr_mst_assetlocn: FilledFormData.assetLocationKey,
      wkr_mst_work_area: FilledFormData.workAreaKey,
      wkr_mst_assetno: FilledFormData.assetNumberKey,
      // wkr_mst_orig_priority: FilledFormData.originalPropertyKey,
      wkr_mst_fault_code: FilledFormData.faultyCodeKey,
      wkr_mst_wr_descs: FilledFormData.workDescription,
      wkr_det_varchar1: email,
      UserId: SelectedUserId,
    };

    Object.entries(requestData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    ImgId.forEach((file, index) => {
      formData.append(`pending_img_rem[${index}]`, file);
    });

    imageFile.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
    // Check if the first file is appended
    const firstFile = imageFile.length > 0 ? imageFile[0] : null;

    try {
      const response = await httpCommon.post(
        "/PendingStatusUpdate.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("üpdate_pending", response);
      if (response.data.status === "SUCCESS") {
        setRefetch(true);
        // setIsLoading(false);
        closeModalPending();

        Swal.fire({
          title: `Work Request No ${workReqestNumber}`,
          text: "Your work request updated successfully",
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            router.push("/dashboard/user/list");
          }
        });
        setTimeout(() => {
          router.push("/dashboard/user/list");
        }, 2000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${response.data.message}`,
        });
      }
    } catch (error) {
      console.error("error___part", error);
    }
  };

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      setImageFile(acceptedFiles);
      const images = watch("images") || [];
      setValue("file", acceptedFiles);
      // Check if the total number of selected files exceeds 3
      if (images.length + acceptedFiles.length > 3) {
        setErrorMessage("You can only select up to 3 photos.");

        // Clear the error message after 3 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 6000);

        return; // Prevent adding more than 3 photos
      }
      setErrorMessage("");

      const newFiles = acceptedFiles.map((file) => ({
        ...file,
        preview: URL.createObjectURL(file),
      }));

      setValue("images", [...images, ...newFiles], { shouldValidate: true });
    },
    [setValue, watch],
  );

  const handleRemoveFile = useCallback(
    (inputFile) => {
      // setImageDialog(false);
      console.log("imageFile", inputFile);
      if (inputFile.preview) {
        const filtered = values.images.filter(
          (file) => file.preview !== inputFile.preview,
        );
        setValue("images", filtered);
      } else {
        const filtered = values.images.filter((file) => inputFile !== file);
        console.log("filteredDat", filtered);
        const Newimg = inputFile.replace(`${url}/`, "");

        const imgId = UserDt.find((item) => item.img_path === Newimg)?.imgId;

        setImgId((pre) => [...pre, imgId]);
        setValue("images", filtered);
      }
    },
    [values.images, UserDt, setValue, url],
  );
  const handleRemoveAllFiles = useCallback(() => {
    setImageDialog(false);
    console.log("files", imagesArr); // Logging that files are being removed
    const result = imagesArr.map((inputFile) => {
      const Newimg = inputFile.replace(`${url}/`, "");
      const imgId = UserDt.find((item) => item.img_path === Newimg)?.imgId;
      setImgId((pre) => [...pre, imgId]);
      return imgId;
    });
    console.log("ImgId", result);
    setValue("images", []); // Clearing the 'images' field
  }, [setValue, imagesArr, url, UserDt]); // Adding setValue as a dependency

  // Handle Image Click
  const handleImageClick = (image) => {
    console.log("Clicked New", image);
  };
  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, "0");
    const month = String(rawDate.getMonth() + 1).padStart(2, "0");
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, "0");
    const minutes = String(rawDate.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const handleDeleteButtonClick = async (image, imageIndex) => {
    const ImgRowId = image.RowID;
    const ImgMstRowId = image.mst_RowID;

    const requestDataImg = {
      site_cd: getHsp,
      ImageRowId: ImgRowId,
      ImageMstRowId: ImgMstRowId,
    };

    const response = await httpCommon.post(
      "/delete_workrequest_attachment_file.php",
      requestDataImg,
    );
    if (response.data.status === "SUCCESS") {
      const updatedUserDtImg = [...UserDtImg];
      updatedUserDtImg.splice(imageIndex, 1);
      setUserDtImg(updatedUserDtImg);
    } else {
      console.log("Image Not Delete");
    }
  };
  const handleCancelClick = async () => {
    setDialogOpen(true);
  };
  const handleConfirmCancel = async () => {
    const cancelReqData = {
      site_cd: getHsp,
      employeeID: getId,
      UserRowID: SelectedUserId,
      reason: textareaValue,
    };
    console.log("CancelReqData", cancelReqData);

    const response = await httpCommon.post(
      "/PendingStatusCancelReq.php",
      cancelReqData,
    );

    if (response.data.status === "SUCCESS") {
      setDialogOpen(false);
      closeModalPending();
      Swal.fire({
        title: "Success!",
        text: "Your request has been cancelled",
        icon: "success",
        timer: 2000,
        showConfirmButton: true,
        allowOutsideClick: false, // Disable outside click
      }).then((result) => {
        if (result.isConfirmed) {
          router.push("/dashboard/user/list");
        }
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      console.log("Not Cancel");
    }
  };

  // handle Level Change
  // level change 2
  const handleLevelChange2 = (e, newValue) => {
    const selectedValues = DrpDataLeval.find(
      (item) => item.ast_lvl_desc === newValue,
    );

    if (selectedValues) {
      setFilledFormData((pre) => ({
        ...pre,
        level: `${selectedValues.ast_lvl_ast_lvl} : ${selectedValues.ast_lvl_desc}`,
        levelKey: selectedValues.ast_lvl_ast_lvl,
        assetLocation: "",
        assetNumber: "",
        assetNumberKey: "",
        assetLocationKey: "",
      }));
    }

    getLocationAsset(
      selectedValues.ast_lvl_ast_lvl,
      FilledFormData.workAreaKey,
    );
  };
  const LevalDropdown = async (workArea) => {
    const cid = localStorage.getItem("ww_Hsp");

    try {
      const response = await httpCommon.get(
        `/levelDropdown.php/?site_cd=${cid}&wrk_Ara=${FilledFormData.workAreaKey}`,
      );
      console.log("levelllllllll", response);
      if (response.data.status === "SUCCESS") {
        setDrpDataLeval(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // get Location DroupDown
  const getLocationAsset = async (level, workArea) => {
    setLabelLoading((pre) => ({
      ...pre,
      assetLocation: true,
    }));
    const id = localStorage.getItem("ww_Hsp");

    try {
      const response = await httpCommon.get(
        `/AssetLocationDropdown.php/?site_cd=${id}&ast_lvl=${level}&wrk_Ara=${workArea}`,
      );

      if (response.data.status === "SUCCESS") {
        setLabelLoading((pre) => ({
          ...pre,
          assetLocation: false,
        }));
        setDrpAssetLocation(response.data.data);
        // getAssetNumber();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Asset DroupDown
  const getAssetNumber = async (workArea, level, assetLoc) => {
    setLabelLoading((pre) => ({
      ...pre,
      assetLocation: true,
    }));
    const id = localStorage.getItem("ww_Hsp");
    try {
      const response = await httpCommon.get(
        `/assetNoDropDown.php/?site_cd=${id}&ast_lvl=${level}&wrk_Ara=${workArea}&asset_locn=${assetLoc}`,
      );
      console.log("response Asset num", response);
      if (response.data.status === "SUCCESS") {
        setLabelLoading((pre) => ({
          ...pre,
          assetLocation: false,
        }));
        // setDrpAsset(response.data.data);
        setDrpAssetNo(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // handleAssetLocation change
  const handleAssetLocation = (e, newValue) => {
    const selectedValues = DrpAssetLocation.find(
      (item) => item.ast_loc_desc === newValue,
    );
    // setValue('wkr_mst_assetno', '');

    // setAssetNoD('');

    if (selectedValues) {
      setFilledFormData((pre) => ({
        ...pre,
        assetLocation: `${selectedValues.ast_loc_ast_loc} : ${selectedValues.ast_loc_desc}`,
        assetLocationKey: selectedValues.ast_loc_ast_loc,
        assetNumberKey: "",
        assetNumber: "",
      }));

      getAssetNumber(
        FilledFormData.workAreaKey,
        FilledFormData.levelKey,
        selectedValues.ast_loc_ast_loc,
      );
    }
  };

  // handle Asset Change
  const handleAssetChange = (event, newValue) => {
    const selectedOptions = DrpAssetNo.find(
      (item) => item.ast_mst_asset_no === newValue,
    );

    if (selectedOptions) {
      setFilledFormData((pre) => ({
        ...pre,
        assetNumberKey: selectedOptions.ast_mst_asset_no,
        assetNumber: `${selectedOptions.ast_mst_asset_no} : ${selectedOptions.ast_mst_asset_shortdesc}`,
      }));
    }
  };

  // handle WorkGroup Change
  const handleWorkGroupChange = (e, newValue) => {
    const selectedOption = DrpWorkGroup.find(
      (item) => item.wrk_grp_desc === newValue,
    );

    if (selectedOption) {
      setFilledFormData((pre) => ({
        ...pre,
        workGroupKey: selectedOption.wrk_grp_grp_cd,
        workGroup: `${selectedOption.wrk_grp_grp_cd} : ${selectedOption.wrk_grp_desc}`,
      }));
    }
  };

  const handlePriorityChange = (e, newValue) => {
    const selectedValues = DrpPriority.find(
      (item) => item.wrk_pri_desc === newValue,
    );
    if (selectedValues) {
      setFilledFormData((pre) => ({
        ...pre,
        originalPropertyKey: selectedValues.wrk_pri_pri_cd,
        originalProperty: `${selectedValues.wrk_pri_pri_cd} : ${selectedValues.wrk_pri_desc}`,
      }));
    }
  };

  // handle field change
  const handleFieldsChange = (e) => {
    setFilledFormData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setWorkGrpKey(e.target.value);
  };
  const handleWorkChange = (event, newValue) => {
    const selectedOption = drpWorkArea.find(
      (item) => item.mst_war_desc === newValue,
    );

    if (selectedOption) {
      setFilledFormData((pre) => ({
        ...pre,
        workAreaKey: selectedOption.mst_war_work_area,
        workArea: `${selectedOption.mst_war_work_area} : ${selectedOption.mst_war_desc}`,
        level: "",
        levelKey: "",
        assetLocation: "",
        assetLocationKey: "",
        assetNumber: "",
        assetNumberKey: "",
      }));

      LevalDropdown(selectedOption.mst_war_work_area);
    }
  };
  // Handle Faulty Change
  const handleFaultChange = (e, newValue) => {
    const selectedValues = DrpFaulty.find(
      (item) => item.wrk_flt_desc === newValue,
    );

    if (selectedValues) {
      setFilledFormData((pre) => ({
        ...pre,
        faultyCodeKey: selectedValues.wrk_flt_fault_cd,
        faultyCode: `${selectedValues.wrk_flt_fault_cd} : ${selectedValues.wrk_flt_desc}`,
      }));
    }
  };
  console.log("userDT", UserDt);
  return (
    <>
      {/* loading img */}
      {/* {loading ? (
        
      ) : null} */}
      <Dialog
        open={loading}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={LoderImg} alt="loderImg" style={{ width: "80px" }} />
        </div>
      </Dialog>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmitData)}>
          <Grid container spacing={4}>
            <Grid xs={12} md={5} className="RejectStatusCs">
              <Card sx={{ px: 3, pb: 5 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 3, mt: 2 }}
                  className="flex items-center gap-2"
                >
                  <Iconify
                    icon="codicon:git-pull-request-new-changes"
                    style={{ marginBottom: "-5px" }}
                  />{" "}
                  Requester Information
                </Typography>

                <Box display="flex" flexDirection="column" rowGap={3}>
                  <div className="usrFrmFld">
                    <FormControl>
                      <InputLabel>Employee ID</InputLabel>
                      <Input type="text" name="empId" value={empl} disabled />
                    </FormControl>
                  </div>

                  {(() => {
                    if (NameDT) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Name</InputLabel>
                            <Input
                              type="text"
                              name="name"
                              disabled
                              onChange={handleNameChange}
                              defaultValue={NameDT || ""}
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="name"
                          label="Name"
                          value=" "
                          variant="filled"
                          disabled
                          onChange={handleNameChange}
                        />
                      </div>
                    );
                  })()}

                  <div>
                    {(() => {
                      if (DeptDT) {
                        return (
                          <div className="usrFrmFld">
                            <FormControl>
                              <InputLabel>Department</InputLabel>
                              <Input
                                type="text"
                                name="department"
                                disabled
                                onChange={handleDeptChange}
                                defaultValue={DeptDT}
                              />
                            </FormControl>
                          </div>
                        );
                      }
                      return (
                        <div className="fuWdt">
                          <RHFTextField
                            id="outlined-basic"
                            name="department"
                            label="Department"
                            disabled
                            value=" "
                            onChange={handleDeptChange}
                            variant="filled"
                          />
                        </div>
                      );
                    })()}
                  </div>
                  <div>
                    {(() => {
                      if (PhnDT) {
                        return (
                          <div className="usrFrmFld">
                            <FormControl>
                              <InputLabel>Contact No</InputLabel>
                              <Input
                                type="text"
                                name="contactNo"
                                disabled
                                onChange={handlePhnChange}
                                defaultValue={PhnDT || ""}
                              />
                            </FormControl>
                          </div>
                        );
                      }
                      return (
                        <div className="fuWdt">
                          <RHFTextField
                            id="outlined-basic"
                            name="contactNo"
                            label="Contact No"
                            disabled
                            value=" "
                            onChange={handlePhnChange}
                            variant="filled"
                          />
                        </div>
                      );
                    })()}
                  </div>
                  {/* Email */}

                  <div>
                    <div className="w-full border border-gray-200 rounded-lg  px-2 py-1 ">
                      <InputLabel>Email</InputLabel>
                      <input
                        className="outline-none w-full"
                        value={email || ""}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </Box>
              </Card>
            </Grid>

            <Grid xs={12} md={7}>
              <Card sx={{ px: 3, pb: 5 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 3, mt: 2 }}
                  className="flex items-center gap-2"
                >
                  <Iconify
                    icon="grommet-icons:workshop"
                    style={{ marginBottom: "-5px" }}
                  />{" "}
                  Work Request Information
                </Typography>
                {console.log("userData", UserDt)}
                <Box display="flex" flexDirection="column" rowGap={3}>
                  <RHFTextField
                    name="requestDate"
                    variant="filled"
                    label="Request Date"
                    inputProps={{ className: "RejinputClass" }}
                    // value={formatDate(UserDt[0]?.wkr_mst_org_date.date)}
                    value={
                      UserDt[0]?.wkr_mst_create_date.date
                        ? formatDate(UserDt[0]?.wkr_mst_create_date.date)
                        : ""
                    }
                  />

                  {/* work area */}

                  <div className="usrFrmFldTwo ">
                    <RHFAutocomplete
                      name="wkr_mst_work_area"
                      label="Work Area"
                      value={FilledFormData.workArea}
                      options={drpWorkArea.map(
                        (DrpDataLeval2) => DrpDataLeval2.mst_war_desc,
                      )}
                      getOptionLabel={(option) => option}
                      onChange={handleWorkChange}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        const { mst_war_desc, mst_war_work_area } =
                          drpWorkArea.filter(
                            (DrpDataLeval1) =>
                              DrpDataLeval1.mst_war_desc === option,
                          )[0];

                        if (!mst_war_desc) {
                          return null;
                        }

                        return (
                          <li {...props} key={mst_war_desc}>
                            <Iconify
                              key={mst_war_desc}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {mst_war_work_area} : {mst_war_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.workArea ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={LoderImg}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* level */}

                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="level"
                      label="Level"
                      // defaultValue={getValues('wkr_mst_location')}
                      value={FilledFormData.level}
                      options={DrpDataLeval.map((item) => item.ast_lvl_desc)}
                      getOptionLabel={(option) => option}
                      onChange={handleLevelChange2}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        if (DrpDataLeval.length > 0) {
                          const selectedItem = DrpDataLeval.find(
                            (item) => item.ast_lvl_desc === option,
                          );
                          console.log(
                            "length",
                            DrpDataLeval.length,
                            selectedItem,
                          );

                          if (!selectedItem) {
                            return (
                              <li {...props}>
                                <Iconify width={28} sx={{ mr: 1 }} />
                                Loading.......
                              </li>
                            );
                          }

                          const { ast_lvl_desc, ast_lvl_ast_lvl } =
                            selectedItem;

                          if (!ast_lvl_desc) {
                            return (
                              <li {...props} key={ast_lvl_desc}>
                                <Iconify
                                  key={ast_lvl_desc}
                                  width={28}
                                  sx={{ mr: 1 }}
                                />
                                Loading.......
                              </li>
                            );
                          }

                          return (
                            <li {...props} key={ast_lvl_desc}>
                              <Iconify
                                key={ast_lvl_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              {ast_lvl_ast_lvl} : {ast_lvl_desc}
                            </li>
                          );
                        }
                        return null;
                      }}
                    />
                  </div>
                  {loadingLabel.level ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={LoderImg}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* Asset Location */}

                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="asset Location"
                      label="Asset Location"
                      value={FilledFormData.assetLocation}
                      options={DrpAssetLocation.map(
                        (DrpDataLeval2) => DrpDataLeval2.ast_loc_desc,
                      )}
                      getOptionLabel={(option) => option}
                      onChange={handleAssetLocation}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderOption={(props, option) => {
                        const { ast_loc_desc, ast_loc_ast_loc } =
                          DrpAssetLocation.filter(
                            (DrpDataLeval1) =>
                              DrpDataLeval1.ast_loc_desc === option,
                          )[0];

                        if (!ast_loc_desc) {
                          return (
                            <li {...props} key={ast_loc_desc}>
                              <Iconify
                                key={ast_loc_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={ast_loc_desc}>
                            <Iconify
                              key={ast_loc_desc}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {ast_loc_ast_loc} : {ast_loc_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.assetLocation ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={LoderImg}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* Asset Number */}

                  {/* Asset Number */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_assetno"
                      label="Asset Number"
                      type="text"
                      value={FilledFormData.assetNumber}
                      options={DrpAssetNo.map(
                        (DrpData2) => DrpData2.ast_mst_asset_no,
                      )}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handleAssetChange}
                      renderOption={(props, option) => {
                        const { ast_mst_asset_no, ast_mst_asset_shortdesc } =
                          DrpAssetNo.filter(
                            (DrpData1) => DrpData1.ast_mst_asset_no === option,
                          )[0];

                        if (!ast_mst_asset_no) {
                          return (
                            <li {...props} key={ast_mst_asset_no}>
                              <Iconify
                                key={ast_mst_asset_no}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={ast_mst_asset_no}>
                            <Iconify
                              key={ast_mst_asset_no}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {ast_mst_asset_no} : {ast_mst_asset_shortdesc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.assetNumber ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={LoderImg}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}
                  {/* work group */}
                  {/* work group */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="workGroup"
                      label="Work Group"
                      value={FilledFormData.workGroup}
                      options={DrpWorkGroup.map((DrpData2) =>
                        DrpData2.wrk_grp_desc.replace(/-/g, ":"),
                      )}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handleWorkGroupChange}
                      // renderOption={(props, option) => {
                      //   const { wrk_grp_desc, wrk_grp_grp_cd } = DrpWorkGroup.filter(
                      //     (DrpData1) => DrpData1.wrk_grp_desc === option
                      //   )[0];

                      //   if (!wrk_grp_desc) {
                      //     return (
                      //       <li {...props} key={wrk_grp_desc}>
                      //         <Iconify key={wrk_grp_desc} width={28} sx={{ mr: 1 }} />
                      //         Loading.......
                      //       </li>
                      //     );
                      //   }

                      //   return (
                      //     <li {...props} key={wrk_grp_desc} value={wrk_grp_grp_cd}>
                      //       <Iconify key={wrk_grp_desc} width={28} sx={{ mr: 1 }} />
                      //       {wrk_grp_desc.replace(/-/g, ":")}
                      //     </li>
                      //   );
                      // }}
                    />
                  </div>
                  {loadingLabel.assetNumber ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img
                        src={LoderImg}
                        alt="loderImg"
                        style={{ width: "30px" }}
                      />
                    </div>
                  ) : null}

                  {/* original Priority */}
                  {/* <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="orig_priority"
                      label="Original Priority"
                      value={FilledFormData.originalProperty}
                      options={DrpPriority.map((DrpData2) => DrpData2.wrk_pri_desc)}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handlePriorityChange}
                      renderOption={(props, option) => {
                        const { wrk_pri_desc, wrk_pri_pri_cd } = DrpPriority.filter(
                          (DrpData1) => DrpData1.wrk_pri_desc === option
                        )[0];

                        if (!wrk_pri_desc) {
                          return (
                            <li {...props} key={wrk_pri_desc}>
                              <Iconify key={wrk_pri_desc} width={28} sx={{ mr: 1 }} />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li {...props} key={wrk_pri_desc} value={wrk_pri_desc}>
                            <Iconify key={wrk_pri_desc} width={28} sx={{ mr: 1 }} />
                            {wrk_pri_pri_cd} : {wrk_pri_desc}
                          </li>
                        );
                      }}
                    />
                  </div>
                  {loadingLabel.priority ? (
                    <div
                    // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                      <img src={LoderImg} alt="loderImg" style={{ width: '30px' }} />
                    </div>
                  ) : null} */}

                  {/* falut code */}
                  <div className="usrFrmFldTwo">
                    <RHFAutocomplete
                      name="wkr_mst_fault_code"
                      label="Fault Code"
                      value={FilledFormData.faultyCode}
                      options={DrpFaulty.map(
                        (DrpData2) => DrpData2.wrk_flt_desc,
                      )}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={handleFaultChange}
                      renderOption={(props, option) => {
                        const { wrk_flt_desc, wrk_flt_fault_cd } =
                          DrpFaulty.filter(
                            (DrpData1) => DrpData1.wrk_flt_desc === option,
                          )[0];

                        if (!wrk_flt_desc) {
                          return (
                            <li {...props} key={wrk_flt_desc}>
                              <Iconify
                                key={wrk_flt_desc}
                                width={28}
                                sx={{ mr: 1 }}
                              />
                              Loading.......
                            </li>
                          );
                        }

                        return (
                          <li
                            {...props}
                            key={wrk_flt_desc}
                            value={wrk_flt_desc}
                          >
                            <Iconify
                              key={wrk_flt_fault_cd}
                              width={28}
                              sx={{ mr: 1 }}
                            />
                            {wrk_flt_fault_cd} : {wrk_flt_desc}
                          </li>
                        );
                      }}
                    />
                  </div>

                  <RHFTextField
                    name="workDescription"
                    label="Request Description"
                    multiline
                    rows={4}
                    defaultValue={FilledFormData.workDescription}
                    value={FilledFormData.workDescription}
                    onChange={handleFieldsChange}
                  />

                  <Typography
                    variant="subtitle2"
                    sx={{ mb: 3, mt: 2 }}
                    className="flex items-center gap-2"
                  >
                    <Iconify
                      icon="material-symbols:settings-photo-camera-sharp"
                      style={{ marginBottom: "-5px" }}
                    />{" "}
                    Reported Images
                  </Typography>
                  <div className="pendingHvr">
                    {errorMessage && (
                      <div className="erMsg">{errorMessage}</div>
                    )}
                    {/* File upload component */}
                    <RHFUpload
                      multiple
                      thumbnail
                      name="images"
                      setImageDialog={setImageDialog}
                      maxSize={3145728}
                      onDrop={handleDrop}
                      onRemove={handleRemoveFile}
                      onRemoveAll={handleRemoveAllFiles}
                      onUpload={() => console.info("ON UPLOAD")}
                      onClick={handleImageDialog}
                      setValue={setValue}
                    />
                  </div>
                </Box>
              </Card>

              <Stack alignItems="inherit" sx={{ mt: 2 }}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  loading={isSubmitting}
                >
                  Update
                </LoadingButton>
              </Stack>

              {/* cancel */}
              <Stack alignItems="inherit" sx={{ mt: 1 }}>
                <LoadingButton
                  // type="submit"
                  variant="contained"
                  className="CancelBtn"
                  onClick={handleCancelClick}
                >
                  Cancel Work Request
                </LoadingButton>
              </Stack>
            </Grid>
          </Grid>
        </form>
      </FormProvider>

      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogContent>
          <h4 className="DaiLgTitlH4">
            Are you sure you want to cancel the work request?
          </h4>
          <textarea
            value={textareaValue}
            onChange={(e) => setTextareaValue(e.target.value)}
            placeholder="Enter a reason for cancellation"
            rows={8}
            cols={70}
            className="customTextarea border"
          />
          {errorMsg && <p className="errormessage">{errorMsg}</p>}
          {/* {errorMsg && <p className="errormessage">{errorMsg}</p>} */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <Dialog open={confirmDialog} onClose={() => setDialogOpen(false)}>
        <DialogContent>
          <h4 className="DaiLgTitlH4">
            Are you Confirm to Cancel this Work Request
          </h4>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog(false)} color="primary">
            No
          </Button>
          <Button
            onClick={handleConfirmCancel}
            color="primary"

            // className="confiem"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Dialog */}
      <Dialog
        open={imageDialog}
        onClose={() => setImageDialog(false)}
        fullWidth
        maxWidth="xs" // Adjust the maximum width for smaller screens
        PaperProps={{
          style: {
            maxHeight: "90vh", // Set maximum height to 80% of the viewport height
            overflowY: "auto", // Enable vertical scrolling if content exceeds maxHeight
            padding: "20px",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 10px 0 10px",
          }}
        >
          <div
            style={{
              alignItems: "center",
              gap: "2px",
              // Conditionally hide on small screens
              display: "flex", // Initially hide
            }}
          >
            <DialogTitle id="alert-dialog-title" className="title">
              {imageData.head}
            </DialogTitle>
          </div>
          <RxCrossCircled
            size={28}
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => setImageDialog(false)}
          />
        </div>
        <div style={{ flex: 1, overflow: "hidden" }}>
          {/* Ensure proper filling */}
          <div
            style={{
              height: "50vh", // Subtract the height of the dialog header
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={imageData.ImageUrl}
              alt="imagePending"
              style={{ maxWidth: "100%", height: "auto", objectFit: "cover" }}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
}

PendingStatus.propTypes = {
  selectedRowID: PropTypes.object,
  closeModalPending: PropTypes.object,
  workReqestNumber: PropTypes.string,
  setRefetch: PropTypes.func,
  refetch: PropTypes.bool,
};
